const home_popup = require('../images/home_popup.jpg');
const paystack_logo = require('../images/paystack_logo.png');

export {
    home_popup,
    paystack_logo
}